import React from 'react';
import { History } from 'history';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { WithNavigation } from './navigation';
import styled, { ThemeProvider } from 'styled-components/macro';
import Search from 'containers/Search';
import withMenu from 'components/HOCs/withMenu';
import scaleSize from '../utils/scale-size';
import theme from 'themes';
import GlobalStyles from './GlobalStyles';
import Overlay from 'containers/Overlay';
import Toast from 'components/Toast';
import GlobalLoaderContainer from 'containers/GlobalLoader';
import MouseControlsContainer from 'containers/MouseControls';
import Modal from 'containers/Modal';
import withBackSupport from 'components/HOCs/withBackSupport';
import EPGWidget from './EPGWidget';
import TechnicalStubPage from 'pages/TechnicalStub';
import ProfilePage from 'pages/Profile';
import ParentalControlPage from 'pages/ParentalControl';
import SectionPage from 'pages/Section';
import DetailsPage from 'pages/Details';
import LoginPage from 'pages/Login';
import PlayerPage from 'pages/Player';
import EPGProgramsPage from 'pages/EPGPrograms';
import ScreenPage from 'pages/Screen';

const StyledApp = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  background-color: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme }) => theme.mainTextColor};
  position: relative;
  overflow: hidden;
`;

interface IApp {
  history: History;
}

const App: React.FC<IApp> = ({ history }) => {
  return (
    <WithNavigation>
      <ThemeProvider theme={theme}>
        <StyledApp>
          <GlobalLoaderContainer />
          <MouseControlsContainer />
          <GlobalStyles />
          <Overlay />
          <Modal />
          <Toast />
          <ConnectedRouter history={history}>
            <EPGWidget />
            <Route exact path={'/'} component={withMenu(SectionPage)} />
            <Route path={'/live-tv'} component={withMenu(SectionPage)} />
            <Route path={'/vod'} component={withMenu(SectionPage)} />
            <Route path={'/cardi-v'} component={withMenu(SectionPage)} />
            <Route path={'/my-watchlist'} component={withMenu(SectionPage)} />
            <Route exact path={'/search'} component={withBackSupport(withMenu(Search))} />
            <Route exact path="/profile" component={withMenu(ProfilePage)} />
            <Route path="/parental-control" component={ParentalControlPage} />
            <Route path="/screen/:id" component={withBackSupport(withMenu(ScreenPage))} />
            <Route exact path={'/details/:type/:id'} component={DetailsPage} />
            <Route path="/login" component={LoginPage} />
            <Route
              path={[
                '/player/movie/:objectId',
                '/player/series/:objectId/:episodeId',
                '/player/channel/:channelId',
              ]}
              component={PlayerPage}
            />
            <Route path="/epg/:channelId" component={EPGProgramsPage} />
            <Route exact path="/technical-stub" component={TechnicalStubPage} />
          </ConnectedRouter>
        </StyledApp>
      </ThemeProvider>
    </WithNavigation>
  );
};

export default App;
